<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import TemplateVariableMappingSelector from './TemplateVariableMappingSelector.vue';

const props = defineProps({
  templateVariables: {
    type: Array,
    required: true,
  },
  csvHeaders: {
    type: Array,
    required: true,
  },
  variableMappings: {
    type: Object,
    required: true,
  },
  totalSteps: {
    type: Number,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['update:variableMappings', 'back', 'next']);

const { t } = useI18n();

const isVariableMappingComplete = computed(() => {
  if (!props.templateVariables.length) return true;
  return props.templateVariables.every(
    variable => props.variableMappings[variable]
  );
});

const handleAutoMap = () => {
  useAlert(
    t('CAMPAIGN.WHATSAPP_CSV.CREATE.FORM.VARIABLE_MAPPING.AUTO_MAP_SUCCESS')
  );
};
</script>

<template>
  <div>
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-medium">
        {{ t('CAMPAIGN.WHATSAPP_CSV.CREATE.FORM.STEPS.VARIABLE_MAPPING') }}
      </h3>
      <div class="flex items-center gap-2">
        <div class="text-xs text-n-slate-10">
          {{
            t('CAMPAIGN.WHATSAPP_CSV.CREATE.FORM.STEP', {
              current: currentStep + 1,
              total: totalSteps,
            })
          }}
        </div>
      </div>
    </div>

    <TemplateVariableMappingSelector
      :template-variables="templateVariables"
      :csv-headers="csvHeaders"
      :variable-mappings="variableMappings"
      @update:variable-mappings="
        newMappings => emit('update:variableMappings', newMappings)
      "
      @auto-map="handleAutoMap"
    />

    <div class="flex justify-between mt-4">
      <Button
        variant="faded"
        color="slate"
        type="button"
        :label="t('CAMPAIGN.WHATSAPP_CSV.CREATE.FORM.BUTTONS.BACK')"
        @click="emit('back')"
      />
      <Button
        variant="solid"
        color="primary"
        type="button"
        :label="t('CAMPAIGN.WHATSAPP_CSV.CREATE.FORM.BUTTONS.NEXT')"
        :disabled="!isVariableMappingComplete"
        @click="emit('next')"
      />
    </div>
  </div>
</template>
